module.exports = __webpack_public_path__ + "media/img/home/img_badge-5c620ffbc56fae5dee5f3b6a73de15b3.png";